// Generated by Melange

import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarCabinetButton(Props) {
  let theme = Props.theme;
  const match = React.useState(function () {
    return false;
  });
  const setShowDropdown = match[1];
  const showDropdown = match[0];
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("a", {
        children: [
          theme === "dark" ? JsxRuntime.jsx("img", {
              className: "w-7 h-7",
              alt: "avatar white",
              src: StaticAsset.src("/static/icons/avatar-white.svg")
            }) : JsxRuntime.jsx("img", {
              className: "w-7 h-7",
              alt: "avatar",
              src: StaticAsset.src("/static/icons/avatar.svg")
            }),
          JsxRuntime.jsx(Buhta_components__Text.PLarge.make, {
            className: Cn.fromList({
              hd: "ml-2 pr-3 border-r border-gray-main",
              tl: {
                hd: theme === "dark" ? "text-white" : "text-links",
                tl: /* [] */ 0
              }
            }),
            children: "Кабинет"
          })
        ],
        className: "flex items-center",
        href: "/org"
      }),
      JsxRuntime.jsx("button", {
        children: showDropdown ? JsxRuntime.jsx("img", {
            className: "w-5 h-5",
            alt: "arrows",
            src: StaticAsset.src(theme === "dark" ? "/static/icons/select-arrows-links.svg" : "/static/icons/select-arrows.svg")
          }) : JsxRuntime.jsx("img", {
            className: "w-5 h-5",
            alt: "arrows",
            src: StaticAsset.src(theme === "dark" ? "/static/icons/select-arrows-white.svg" : "/static/icons/select-arrows-links.svg")
          }),
        className: "ml-1.5",
        onClick: (function (param) {
          Curry._1(setShowDropdown, (function (param) {
            return true;
          }));
        })
      }),
      showDropdown ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                  children: Buhta_landing__I18n.transComponent(intl, "admin_cab")
                }),
                className: "p-2 cursor-pointer hover:bg-gray-pale block",
                href: "/admin"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                  children: Buhta_landing__I18n.transComponent(intl, "profile_settings")
                }),
                className: "p-2 cursor-pointer hover:bg-gray-pale block",
                href: "/profile"
              }),
              JsxRuntime.jsx("hr", {
                className: "my-2"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("a", {
                  children: [
                    JsxRuntime.jsx(Buhta_components__Text.P.make, {
                      className: "text-alert",
                      children: Buhta_landing__I18n.transComponent(intl, "logout")
                    }),
                    JsxRuntime.jsx("img", {
                      alt: "logout red",
                      src: StaticAsset.src("/static/icons/logout-red-20.svg")
                    })
                  ],
                  className: "flex justify-between items-center",
                  href: "/logout"
                }),
                className: "p-2 cursor-pointer hover:bg-gray-pale"
              })
            ],
            className: "bg-white rounded-sm shadow-kkms w-55 absolute right-10 top-24 p-2"
          }),
          className: "fixed inset-0",
          onClick: (function (param) {
            Curry._1(setShowDropdown, (function (param) {
              return false;
            }));
          })
        }) : null
    ],
    className: "rounded-sm px-2 py-1.5 flex items-center border border-gray-main"
  });
}

const make = NavbarCabinetButton;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
